import { Badge } from '@/components/ui/badge';

export type EventHeaderStatus = 'going' | 'ended' | 'closed' | 'open' | 'free';

interface EventHeaderProps {
  title: string;
  status: EventHeaderStatus;
  locationType: 'PHYSICAL' | 'VIRTUAL' | 'TO_BE_DECIDED';
}

const STATUS_TEXT: Record<EventHeaderStatus, string> = {
  going: 'Registered',
  ended: 'Event has ended',
  closed: 'Registration closed',
  open: 'Registration open',
  free: 'Free entry',
};

export function EventHeader({ title, status, locationType }: EventHeaderProps) {
  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <Badge variant={status === 'going' ? 'secondary' : 'outline'}>
          {status === 'going' ? "You're going" : locationType}
        </Badge>
        <span className="text-sm text-muted-foreground">{STATUS_TEXT[status]}</span>
      </div>
      <h1 className="text-4xl font-bold tracking-tight text-foreground">{title}</h1>
    </div>
  );
}
